/**
 * @module components/TabsTableHazard
 * @author Charles Blais <charles.blais@canada.ca>
 * 
 * Tab display of various hazard table displays
 * 
 * The following assumes that user specified only contains one site designation
 */

import { useLanguageState } from '../contexts/language-state-provider';

import TableModel from './table/table-model';

import { vs30toSiteDesignation } from '../lib';


type Props = {
  variables: HazardParameters
  data: SiteDesignationsXVResponse | SiteDesignationsXSResponse,
}


/**
 * React component
 * ===============
 */
const TabsTableModel = ({
  variables,
  data,
}: Props) => {
  const [ lang ] = useLanguageState();

  const selected = vs30toSiteDesignation(data.userSpecified[0].vs30);

  // There are two types of displays depending if the requested
  // is "nbc" or "canSHM".
  let details = lang.tab.tablesDetail
  if ( /^nbc/i.test(variables.code) ) {
    details = <>{lang.tab.tablesDetailNBC}{lang.tab.tablesDetail}</>;
  }

  return (
    <>
      {details}
      <TableModel
        siteDesignations={data}
        meta={variables}
        defaultFiltered={[{
          id: 'siteDesignation',
          value: selected,
        }]}
      />
    </>
  );
};

export default TabsTableModel;